import React from "react";
import "../css/index.css";
import { Link, useNavigate } from "react-router-dom";
const Homepage = () => {
  return (
    <div className="siteWrapper">
      <div className="homepage-wrapper">
      <div className="hero-container">
        <div className="hero-copy">
          <h1>
            graduate from
            <br />
            laundry day!
          </h1>
          <p>
            Easily join and post that you need to wash your clothes. Our washers
            will respond promptly and give you the best service!
          </p>
          <Link to={"/feed"} className="button">
            Take a look now
            <img className="arrow" src="arrow-right-solid.svg" alt="Logo" />
          </Link>
        </div>

        <div className="hero">
          <img src="iuLogo.webp" alt="Logo" className="iuLogo" />
        </div>
      </div>

      <div className="sectionContainer">
        <div className="homeSection">
          <h3>Request a wash</h3>
          <p>
            Easily join and post that you need to wash your clothes. Our washers
            will respond promptly and give you the best service!
          </p>
          <Link to={"/wearer-signup"} className="button">
            Sign up
          </Link>
        </div>
        <div className="homeSection">
          <h3>Be available to wash</h3>
          <p>
            Are you available to become a washer? Sign up to become one today!
          </p>
          <Link to={"/washer-signup"} className="button">
            Sign up
          </Link>
        </div>
      </div>
      <div className="gates-div">
        {/* <img src="gates2.jpeg" alt="gates" className="gates" /> */}
        <h3 className="gatesText">Start today, it’s so simple.</h3>
      </div>

      <div className="sectionContainer p2">
        <div className="homeSection p2">
          <img src="icon_globe.png" alt="Logo" />
          <h3>Connect with others</h3>
          <p>
            Join many other students in Dormee's large network of students. All
            of which are either washers or wearers. In a market-like
            environment, washers and wears are able to communicate to accomplish
            the most efficient service.
          </p>
        </div>
        <div className="homeSection p2">
          <img src="icon_avatar.png" alt="Logo" />
          <h3>Easily switch what role you are in</h3>
          <p>
            Sign up as a washer and a wearer to easily switch roles you want to
            use at any time. Make a laundry post, then within the next week,
            pick up three laundry orders by using you washer account.
          </p>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Homepage;